/* unplugin-vue-components disabled */import { render } from "./upload-button.vue?vue&type=template&id=9a7b0504&scoped=true"
import script from "./upload-button.vue?vue&type=script&lang=js"
export * from "./upload-button.vue?vue&type=script&lang=js"

import "./upload-button.vue?vue&type=style&index=0&id=9a7b0504&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7b0504"],['__file',"src/controls/upload-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a7b0504"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a7b0504', __exports__)) {
    api.reload('9a7b0504', __exports__)
  }
  
  module.hot.accept("./upload-button.vue?vue&type=template&id=9a7b0504&scoped=true", () => {
    api.rerender('9a7b0504', render)
  })

}


export default __exports__